// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27n_G","left":"styles_left__31L8L","desktopActions":"styles_desktopActions__3F7Li","title":"styles_title__2jmCv"};